import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Form, Input, Modal, Select, Table} from 'antd';
import moment from 'moment';
import util from '@util/index';
import {queryInvoiceList} from '@api/incubator/invoice';
import SelectCustom from '../incubator/comm/SelectCustom';

class Demo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTips: false,
      incubatorUuid: '',
      data: {
        list: [],
        pagination: {},
      },
      customUuid: '',
      selectedRowKeys: [],
    };
  }

  componentDidMount() {}

  getInvoiceList = () => {
    queryInvoiceList({
      customUuid: this.customUuid,
      invalid: 0,
      limit: 5,
      start: this.current || 1,
      incubatorUuid: this.state.incubatorUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data,
            pagination: {
              current: this.current || 1,
              total: res.totalSize,
              pageSize: 5,
            },
          },
        });
      }
    });
  };

  handleCustomChange = (e, option) => {
    this.customUuid = e;
    this.setState({
      customUuid: e,
    });
    this.getInvoiceList();
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.getInvoiceList(pagination.current);
  };

  incubatorChange = e => {
    this.setState({
      incubatorUuid: e,
    });
    return e;
  };

  onChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length < 1) {
      this.setState({
        showTips: true,
      });
    } else {
      this.setState({
        showTips: false,
      });
    }
    this.props.form.validateFields(['incubatorUuid', 'customUuid', 'reason'], (err, values) => {
      if (!err) {
        this.props.invalidInvoice({
          uuids: selectedRowKeys,
          reason: values.reason,
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '开票编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/invoice_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '收款公司',
        dataIndex: 'company',
        key: 'company',
        width: 150,
      },
      {
        title: '开票金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '开票时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        width: 80,
        render: (text, record) => {
          return record.finishTime ? (
            <span style={{ color: 'red' }}>已完成</span>
          ) : (
            <span>处理中</span>
          );
        },
      },
      {
        title: '作废状态',
        dataIndex: 'invalid',
        width: 80,
        render: (text, record) => {
          return record.invalid ? <span style={{ color: 'red' }}>已作废</span> : null;
        },
      },
    ];
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      data: { list, pagination },
      showTips,
      selectedRowKeys,
      customUuid,
    } = this.state;
    const { data } = this.props;
    const rowSelection = {
      onChange: this.onChange,
      selectedRowKeys,
    };

    let element;
    if (list.length > 0) {
      element = null;
    } else {
      element = customUuid ? (
        <span style={{ color: 'red', paddingLeft: '8px' }}>该公司下没有发票可作废</span>
      ) : null;
    }
    return (
      <Modal
        visible
        title="选择作废发票"
        onCancel={() => this.props.onCancel(false)}
        width={700}
        onOk={this.handleSubmit}
      >
        <Form.Item label="选择孵化器">
          {getFieldDecorator('incubatorUuid', {
            rules: [{ required: true, message: '请选择预算组' }],
            getValueFromEvent: this.incubatorChange,
          })(
            <Select
              showSearch
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="请选择孵化器"
              style={{ width: '45%' }}
            >
              {this.props.incubatorData.map((item, index) => {
                return <Select.Option key={item.uuid}>{item.name}</Select.Option>;
              })}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="客户名称">
          {getFieldDecorator('customUuid', {
            rules: [{ required: true, message: '请选择客户!' }],
          })(
            <SelectCustom
              onChange={this.handleCustomChange}
              incubatorUuid={this.state.incubatorUuid}
              customName={data ? data.custom : ''}
            />,
          )}
          {element}
        </Form.Item>
        {customUuid && list.length > 0 ? (
          <Table
            dataSource={list}
            columns={this.columns()}
            rowKey="uuid"
            pagination={pagination}
            rowSelection={rowSelection}
            onChange={this.onTableChange}
          />
        ) : null}
        {showTips ? <span style={{ color: 'red' }}>请至少一条记录进行作废！</span> : null}
        <Form.Item label="作废理由">
          {getFieldDecorator('reason', {
            rules: [{ required: true, message: '请填写作废理由!' }],
            initialValue: data ? data.price : '',
          })(<Input />)}
        </Form.Item>
      </Modal>
    );
  }
}

export default connect(state => ({ incubatorData: state.incubator_list }))(
  Form.create({ wrappedComponentRef: true })(Demo),
);



// WEBPACK FOOTER //
// ./src/components/flow/ModalInvalid.js